import {
  createGet,
  createGetByDates,
  createPost,
  createPatch,
  createDownload,
} from "./base.js";

const reportName = "motivationMNG";

export const Get = createGet(reportName);
export const GetByDates = createGetByDates(reportName);
export const Post = createPost(reportName);
export const Patch = createPatch(reportName);
export const Donwload = createDownload(`${reportName}/download`);
